import getLang from 'academy-common-lib/utils/getLang';
import { CategoriesSubSections, HubspotToolsSubSections, getSearchUrl } from '../search';
import { UserAttributeKeys, useUserAttribute } from '../userAttributes';
import { wizardEnabledLanguages } from '../../constants/WizardRecommendationConstants';
import { WIZARD_PAGE_SIZE } from './wizardConsts';
import { useSearch } from 'academy-common-lib/features/search/hooks/useSearch';
export const useWizardResults = ({
  learningInterest,
  pageLength = WIZARD_PAGE_SIZE
}) => {
  const language = getLang().toUpperCase();
  const {
    selectedCategoryGroup,
    selectedToolsGroup,
    selectedCategory,
    selectedTool,
    isToolsSelected,
    showOnlyCerts
  } = learningInterest;
  const {
    userAttribute: includeEnglishState,
    userAttributesError: includeEnglishStateError,
    userAttributeLoading: includeEnglishStateLoading
  } = useUserAttribute(UserAttributeKeys.PREAPPLIED_FILTER_CHANGED);
  let categories;
  let hubSpotSoftware;
  if (selectedCategory && selectedCategoryGroup !== selectedCategory) categories = [selectedCategory];else if (selectedCategoryGroup) categories = CategoriesSubSections[selectedCategoryGroup];
  if (selectedTool && selectedToolsGroup !== selectedTool) hubSpotSoftware = [selectedTool];else if (selectedToolsGroup) {
    var _HubspotToolsSubSecti;
    hubSpotSoftware = (_HubspotToolsSubSecti = HubspotToolsSubSections[selectedToolsGroup]) !== null && _HubspotToolsSubSecti !== void 0 ? _HubspotToolsSubSecti : [selectedToolsGroup];
  }
  const loadDataInUsersLanguageOnly = wizardEnabledLanguages.includes(language.toLowerCase()) && !includeEnglishState;
  const languages = loadDataInUsersLanguageOnly || language === 'EN' ? [language] : [language, 'EN'];
  const variables = {
    pageLength,
    shouldFilterDeprecated: true,
    offset: {
      cursor: 0
    },
    categories,
    hubSpotSoftware,
    languages,
    hasAwardsOnly: showOnlyCerts
  };
  const {
    searchResults: searchResults,
    totalCount: resultsCount,
    searchResultsLoading: searchResultsLoadingAll,
    searchResultsError: searchResultsErrorAll,
    correlationId
  } = useSearch({
    variables
  });
  const resultsUrl = getSearchUrl({
    category: selectedCategory,
    tool: selectedTool,
    showOnlyCerts,
    language: languages
  });
  return {
    searchResults,
    resultsCount,
    isRequesting: searchResultsLoadingAll || includeEnglishStateLoading,
    error: searchResultsErrorAll || includeEnglishStateError,
    selectedCategoryGroup,
    selectedToolsGroup,
    selectedCategory,
    selectedTool,
    isToolsSelected,
    resultsUrl,
    searchCriteria: variables,
    correlationId
  };
};